// Akses menu per perusahaan untuk Admin Pusat (role 2) dan Admin Cabang (role 3).
// Diatur Superadmin di menu Pengaturan Menu; disimpan di tabel m_menu_akses.
// Menu tanpa pengaturan tetap tampil sesuai aturan bawaan (_nav.js, hideForRoles).
import { reactive } from 'vue'
import axios from 'axios'
import nav from '@/_nav.js'

const state = reactive({ rows: {} }) // menu_key -> { role_2, role_3 }

export async function loadMenuAkses() {
  const idPerusahaan = localStorage.getItem('id_perusahaan')
  if (!idPerusahaan) return
  try {
    const response = await axios.post(
      localStorage.getItem('url') + 'master/get_menu_akses',
      { id_perusahaan: idPerusahaan },
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-API-KEY': localStorage.getItem('key') },
        timeout: 8000,
      },
    )
    const rows = {}
    ;(response.data.data || []).forEach((r) => {
      rows[r.menu_key] = { role_2: r.role_2 == 1, role_3: r.role_3 == 1 }
    })
    state.rows = rows
  } catch (err) {
    console.error('Gagal memuat akses menu:', err)
  }
}

// Bawaan sidebar (tanpa pengaturan perusahaan)
export function aksesBawaan(item, role) {
  // Menu modul khusus (mis. coffee shop) tersembunyi sampai diaktifkan per perusahaan di Pengaturan Menu
  if (item.modul) return false
  return !(item.hideForRoles || []).includes(String(role))
}

// Menu modul hanya mengikuti Pengaturan Menu; menu biasa juga tunduk pada hideForRoles
function tampil(item, role) {
  return item.modul ? bolehMenu(item, role) : aksesBawaan(item, role) && bolehMenu(item, role)
}

// Menu boleh tampil untuk role ini (role 1 & 4 tidak diatur per perusahaan)
export function bolehMenu(item, role, rows = state.rows) {
  if (!['2', '3'].includes(String(role))) return true
  const atur = rows[item.to]
  return atur ? atur[`role_${role}`] : aksesBawaan(item, role)
}

// Saring daftar menu, lalu buang judul kelompok yang tidak punya menu tersisa
export function saringNav(items, role) {
  const sisa = items.filter((item) => item.component === 'CNavTitle' || tampil(item, role))
  return sisa.filter((item, i) => {
    if (item.component !== 'CNavTitle') return true
    const berikut = sisa[i + 1]
    return berikut && berikut.component !== 'CNavTitle'
  })
}

// Path route yang ditutup untuk role ini (dipakai router guard)
export function pathDitutup(path, role) {
  if (!['2', '3'].includes(String(role))) return false
  // Abaikan garis miring di akhir: router juga punya alias lama seperti /order-barang/
  const bersih = (p) => String(p || '').replace(/\/+$/, '') || '/'
  const item = nav.find((n) => n.to && bersih(n.to) === bersih(path))
  return item ? !tampil(item, role) : false
}

// Menu pertama yang terbuka, untuk akun yang halaman berandanya ditutup
export function menuPertama(role) {
  const item = nav.find((n) => n.to && tampil(n, role))
  return item ? item.to : null
}

export default state
